import { render, staticRenderFns } from "./express-code-link.vue?vue&type=template&id=4cbfb77c"
import script from "./express-code-link.vue?vue&type=script&lang=js"
export * from "./express-code-link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports